import React, { useState, useEffect, useRef } from "react"
import lottie from "lottie-web"
import { graphql, useStaticQuery } from "gatsby"

const WinAndHikeGewinnAnimation = (props) => {
  const [logoUrl, setLogoUrl] = useState(null)
  const ref = useRef()
  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "win_and_hike_gewinn" }) {
        publicURL
      }
    }
  `)
  useEffect(() => {
    setLogoUrl(data.file.publicURL)
  }, [])
  useEffect(() => {
    const refToUse = ref
    refToUse.current.innerHTML = ""
    lottie.loadAnimation({
      container: refToUse.current,
      renderer: "svg",
      loop: props.loop ?? true,
      autoplay: true,
      path: logoUrl,
    })
  }, [logoUrl])

  return <div {...props} ref={ref}></div>
}

export default WinAndHikeGewinnAnimation
